export interface RowDataTransaction {
    addIndex?: number | null;
    add?: any[] | null;
    remove?: any[] | null;
    update?: any[] | null;
}
